﻿export abstract class EventBase {}
